import { withStyles } from '@material-ui/core';

import StatisticsDoubleLineChart from './component';
import styles from './styles';

export default withStyles(styles)(StatisticsDoubleLineChart);
